import {
  BREAKPOINTS_V3,
  SwipeableProgressBar,
  SwipeableProvider,
  SwipeableSlider,
  useMediaQuery,
} from '@jouzen/ecom-components';
import { useEffect, useState } from 'react';

import Motion from '@/app/components/Motion';
import SwipeableNavButtons from '@/app/components/SwipeableNavButtons';

import LandingPageMembershipTabContentCard, {
  type LandingPageMembershipTabContentCardProps,
} from './LandingPageMembershipTabContentCard';
import LandingPageMembershipTabContentFeaturedImage, {
  type LandingPageMembershipTabContentFeaturedImageProps,
} from './LandingPageMembershipTabContentFeaturedImage';

export interface LandingPageMembershipTabContentProps {
  readonly cards: LandingPageMembershipTabContentCardProps[];
  readonly featuredImage: LandingPageMembershipTabContentFeaturedImageProps;
}

const LandingPageMembershipTabContent = ({
  cards,
  featuredImage,
}: LandingPageMembershipTabContentProps): JSX.Element => {
  const isDesktop = useMediaQuery(`(min-width: ${BREAKPOINTS_V3.large}px)`);
  const [featuredImageVisible, setFeaturedImageVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (isDesktop && !featuredImageVisible) {
      setFeaturedImageVisible(true);
    }
    if (!isDesktop && featuredImageVisible) {
      setFeaturedImageVisible(false);
    }
  }, [featuredImageVisible, isDesktop]);

  return (
    <Motion
      className="w-full"
      data-cy="landing-page-membership-tab-content"
      initial={{ opacity: 0 }}
      transition={{ duration: 0.75, type: 'tween', delay: 0.25 }}
      whileInView={{ opacity: 1 }}
    >
      <SwipeableProvider>
        <SwipeableSlider>
          {featuredImageVisible ? (
            <LandingPageMembershipTabContentFeaturedImage {...featuredImage} />
          ) : null}
          {cards.map((card) => (
            <LandingPageMembershipTabContentCard key={card.title} {...card} />
          ))}
        </SwipeableSlider>
        <div className="relative mt-10 lg:mt-7">
          <SwipeableProgressBar />
          <SwipeableNavButtons
            buttonClassName="lg:px-4 lg:py-5"
            className="pt-2 pb-0 lg:pt-3"
            color="sandstoneLight"
          />
        </div>
      </SwipeableProvider>
    </Motion>
  );
};

export default LandingPageMembershipTabContent;
